import { Component, ElementRef } from '@angular/core';
import { NavController, NavParams, Platform } from 'ionic-angular';

import { ConsumerOfferManagerHandler } from '../../providers/consumer-offer-handler';
import { ConsumerOfferManagerPage } from '../consumer-offer-manager/consumer-offer-manager';

import { PushNotificationHandlerProvider } from '../../providers/push-notification-handler';
import { ConsumerBusinessHandlerProvider } from '../../providers/consumer-business-handler';	
import { Globals } from '../../providers/globals';

import { ConsumerBusinessMainHandlerProvider } from '../../providers/consumer-business-main-handler';

import { LaunchNavigator, LaunchNavigatorOptions } from '@ionic-native/launch-navigator';

declare var google: any;

@Component({
  selector: 'page-consumer-business-offer-list',
  templateUrl: 'consumer-business-offer-list.html',
})
export class ConsumerBusinessOfferListPage {
  	business: any = {
		Id: 0,
		ImagePath: ""
	};

	businessId: any;
	filePath: any;
	businessFilePath: any;

	hasOffers: any = true;

	offers: any = [];

	requiresReload: boolean = false;
	isLoading: boolean = false;
	isRefreshing: boolean = false;

	map: any;

	constructor(
		public consumerBusinessMainHandlerProvider: ConsumerBusinessMainHandlerProvider, 
		public navCtrl: NavController,
		public navParams: NavParams,
		public offerHandler: ConsumerOfferManagerHandler,
		public consumerBusinessHandlerProvider: ConsumerBusinessHandlerProvider,
		public pushNotificationHandlerProvider: PushNotificationHandlerProvider,
		private elRef: ElementRef,
		public globals: Globals,
		public platform: Platform,
		private launchNavigator: LaunchNavigator
	) {
		this.filePath = this.globals.fileUrl;
		this.business = this.consumerBusinessMainHandlerProvider.business;	
		this.businessFilePath = this.globals.fileUrl + this.business.ImagePath;

		this.fetchBusiness(null);
	}

	doRefresh(refresher) {
		this.isRefreshing = true;

		this.fetchBusiness(()=>{
			this.isRefreshing = false;
		  	refresher.complete();
		})
	}  	

	ionViewDidLoad() {
		if(!this.requiresReload){
			this.loadBusinessInfo();
		}
	}	

	loadBusinessInfo(){

		this.loadOffers(null);
	}

	fetchBusiness(cb){
		this.isLoading = (!this.isRefreshing) ? true : false;

		this.consumerBusinessHandlerProvider.getBusinessByIdAndUser(
		{
			id: this.business.Id,
			cb: (business)=>{
				this.business = business;		

				this.loadBusinessInfo()

				if(typeof cb == "function")
					cb()	

				this.isLoading = false;
			}
		})
	}

	loadOffers(cb){
		this.offerHandler.getOffersByBusinessId({
			businessId: this.business.Id,
			page: 1,
			size: 20,
			cb:(offers)=>{
				if(offers.length == 0){
					this.hasOffers = false;
				}else{
					this.hasOffers = true;
				}

				this.offers = offers;

				if(typeof cb == "function")
					cb()			
			}
		})
	}	

	manageOffer($e, offer){
	    this.navCtrl.push(ConsumerOfferManagerPage, {
	      offer: offer
	    });				
	}
}



// WEBPACK FOOTER //
// ./src/pages/consumer-business-offer-list/consumer-business-offer-list.ts